import * as client from '../../services/client';
import { TYPES, PATHS } from '../../common/constants';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { stopPRLoading, startPRLoading, startFormLoading, stopFormLoading } from './loader';
import { setValidation } from './validation';


const fetchCommonIssuesDone = payload => ({
    type: TYPES.FETCH_COMMON_ISSUES_DONE,
    payload,
});
const saveCommonIssuesDone = payload => ({
    type: TYPES.SAVE_COMMON_ISSUE_DONE,
    payload,
});
const updateCommonIssuesDone = payload => ({
  type: TYPES.UPDATE_COMMON_ISSUE_DONE,
  payload,
});
const deleteCommonIssueDone = payload => ({
    type: TYPES.DELETE_COMMON_ISSUE_DONE,
    payload,
});

export const clearCommonIssues = () => ({
  type: TYPES.CLEAR_COMMON_ISSUE_DONE
})

export const fetchCommonIssues = (assetId) => dispatch => {
    dispatch(startPRLoading())
    return client.getfetchCommonIssues(assetId)
      .then(
        response => {
          if (response.ok || response.status === 200) {
            response.json().then(
              (responsejson) => {
                if(responsejson.statusCode === 200) {
                  dispatch(fetchCommonIssuesDone(responsejson.data))
                   dispatch(stopPRLoading())
                } else {
                   dispatch(stopPRLoading())
                }
              }
            )
          } else {
             dispatch(stopPRLoading())
          }
        }
      );
  };
  
  export const saveCommonIssue = (params) => dispatch => {
    dispatch(startFormLoading())
    return client.saveCommonIssue(params)
      .then(
        response => {
          if (response.ok || response.status === 200) {
            response.json().then(
              (responsejson) => {
                if(responsejson.statusCode === 200) {
                    dispatch(setValidation('Success'))
                 dispatch(saveCommonIssuesDone(responsejson.data))
                 toast.success('ⓘ Common Issue has been added.',{autoClose:10000,position:'top-center'})
                  dispatch(stopFormLoading())
                } else {
                  dispatch(stopFormLoading())
                  toast.error(' 🚫 Something went wrong with adding a common issue, please try again.',{autoClose:12000,position:'top-center'})
                }
              }
            )
          } else {
            toast.error(' 🚫 Something went wrong with adding a common issue, please try again.',{autoClose:12000,position:'top-center'})
            dispatch(stopFormLoading())
          }
        }
     );
  };

  export const updateCommonIssue = (params) => dispatch => {
    
    dispatch(startFormLoading())
    return client.updateCommonIssue(params)
      .then(
        response => {
          if (response.ok || response.status === 200) {
            response.json().then(
              (responsejson) => {
                if(responsejson.statusCode === 200) {
                    dispatch(setValidation('Success'))
                 dispatch(updateCommonIssuesDone(responsejson.data))
                 toast.success('ⓘ Common Issue has been updated.',{autoClose:10000,position:'top-center'})
                  dispatch(stopFormLoading())
                } else {
                  dispatch(stopFormLoading())
                  toast.error(' 🚫 Something went wrong with adding a common issue, please try again.',{autoClose:12000,position:'top-center'})
                }
              }
            )
          } else {
            toast.error(' 🚫 Something went wrong with adding a common issue, please try again.',{autoClose:12000,position:'top-center'})
            dispatch(stopFormLoading())
          }
        }
     );
  };

  export const deleteCommonIssue = (id) => dispatch => {
    // dispatch(startFormLoading())
    return client.deleteCommonIssue(id)
      .then(
        response => {
          if (response.ok || response.status === 200) {
            response.json().then(
              (responsejson) => {
                if(responsejson.statusCode === 200) {
                 dispatch(deleteCommonIssueDone(id))
                 toast.success('ⓘ Common issue has been deleted .',{autoClose:10000,position:'top-center'})
                  dispatch(stopFormLoading())
                } else {
                  dispatch(stopFormLoading())
                  toast.error(' 🚫 Something went wrong with deleting a common issue, please try again.',{autoClose:12000,position:'top-center'})
                }
              }
            )
          } else {
            toast.error(' 🚫 Something went wrong with deleting a common issue, please try again.',{autoClose:12000,position:'top-center'})
            dispatch(stopFormLoading())
          }
        }
     );
  };

  export const fetchLatestIssues = (itemId, issueId) => dispatch => {
    return client.fetchLatestIssues(itemId, issueId)
      .then(
        response => {
          if (response.ok || response.status === 200) {
            response.json().then(
              (responsejson) => {
                  dispatch(fetchCommonIssuesDone(responsejson))
                  dispatch(stopPRLoading())
              }
            )
          } else {
            dispatch(stopPRLoading())
          }
        }
      );
  };